import React, { ComponentPropsWithRef, PropsWithChildren } from 'react';
import { ReactComponent as LogoAdmin } from './svg/logo-admin.svg';
import { ReactComponent as LogoGoogle } from './svg/logo-google.svg';
import { ReactComponent as LogoAdminShort } from './svg/logo-admin-short.svg';
import { ReactComponent as LogoAdminWord } from './svg/logo-admin-word.svg';
import { ReactComponent as Users } from './svg/users.svg';
import { ReactComponent as Chevron } from './svg/chevron.svg';
import { ReactComponent as Plans } from './svg/plans.svg';
import { ReactComponent as Coupon } from './svg/coupon.svg';
import { ReactComponent as Coaches } from './svg/user-coach.svg';
import { ReactComponent as Paperclip } from './svg/paperclip.svg';
import { ReactComponent as Trash } from './svg/trash.svg';
import { ReactComponent as Times } from './svg/times.svg';
import { ReactComponent as TimesCircle } from './svg/times-circle.svg';
import { ReactComponent as MagnifyingGlass } from './svg/magnifying-glass.svg';
import { ReactComponent as IllustBox } from './svg/illust-box.svg';
import { ReactComponent as Circles } from './svg/bg-circles.svg';
import { ReactComponent as CirclesAlt } from './svg/bg-circles-alt.svg';
import { ReactComponent as TriangleExclaimation } from './svg/triangle-exclaimation.svg';
import { ReactComponent as CircleExclaimation } from './svg/circle-exclaimation.svg';
import { ReactComponent as CircleTickOutline } from './svg/circle-tick-outline.svg';
import { ReactComponent as Filter } from './svg/filter.svg';
import { ReactComponent as ImageDefault } from './svg/image-default.svg';
import { ReactComponent as Globe } from './svg/globe.svg';
import { ReactComponent as ArchiveBox } from './svg/archive-box.svg';
import { ReactComponent as Edit } from './svg/edit.svg';
import { ReactComponent as UsersMove } from './svg/users-move.svg';
import { ReactComponent as User } from './svg/user.svg';
import { ReactComponent as UserCoach } from './svg/user-coach.svg';
import { ReactComponent as Mail } from './svg/mail.svg';
import { ReactComponent as MailStar } from './svg/mail-star.svg';
import { ReactComponent as SmartPhone } from './svg/smartphone.svg';
import { ReactComponent as LocationPoint } from './svg/location-point.svg';
import { ReactComponent as Calendar } from './svg/calendar.svg';
import { ReactComponent as Link } from './svg/link.svg';
import { ReactComponent as ReceiptTorn } from './svg/receipt-torn.svg';
import { ReactComponent as CheckCircle } from './svg/check-circle.svg';
import { ReactComponent as CircleOutline } from './svg/circle-outline.svg';
import { ReactComponent as EditList } from './svg/edit-list.svg';
import { ReactComponent as Plus } from './svg/plus.svg';
import { ReactComponent as ClipboardNotes } from './svg/clipboard-notes.svg';
import { ReactComponent as ArrowBoth } from './svg/arrow-both.svg';
import { ReactComponent as Logout } from './svg/logout.svg';
import { ReactComponent as PlusBlack } from './svg/plus-black.svg';
import { ReactComponent as EditListBlack } from './svg/edit-list-black.svg';
import { ReactComponent as InfoCircle } from './svg/info-circle.svg';
import { ReactComponent as CardLogin } from './svg/card-login.svg';
import { ReactComponent as RedTrash } from './svg/red-trash.svg';
import { ReactComponent as UploadLocation } from './svg/upload-location.svg';

// .svg naming convention
// kebab-case
// (main)-(attributes)-... (e.g. times-circle.svg)

const iconMapping = [
  { name: 'logo-admin', svg: <LogoAdmin /> },
  { name: 'logo-google', svg: <LogoGoogle /> },
  { name: 'logo-admin-short', svg: <LogoAdminShort /> },
  { name: 'logo-admin-word', svg: <LogoAdminWord /> },
  { name: 'users', svg: <Users /> },
  { name: 'plans', svg: <Plans /> },
  { name: 'coupon', svg: <Coupon /> },
  { name: 'chevron', svg: <Chevron /> },
  { name: 'coaches', svg: <Coaches /> },
  { name: 'paperclip', svg: <Paperclip /> },
  { name: 'trash', svg: <Trash /> },
  { name: 'times', svg: <Times /> },
  { name: 'times-circle', svg: <TimesCircle /> },
  { name: 'magnifying-glass', svg: <MagnifyingGlass /> },
  { name: 'illust-box', svg: <IllustBox /> },
  { name: 'bg-circles', svg: <Circles /> },
  { name: 'bg-circles-alt', svg: <CirclesAlt /> },
  { name: 'triangle-exclaimation', svg: <TriangleExclaimation /> },
  { name: 'circle-exclaimation', svg: <CircleExclaimation /> },
  { name: 'circle-tick-outline', svg: <CircleTickOutline /> },
  { name: 'filter', svg: <Filter /> },
  { name: 'image-default', svg: <ImageDefault /> },
  { name: 'globe', svg: <Globe /> },
  { name: 'archive-box', svg: <ArchiveBox /> },
  { name: 'edit', svg: <Edit /> },
  { name: 'users-move', svg: <UsersMove /> },
  { name: 'user', svg: <User /> },
  { name: 'user-coach', svg: <UserCoach /> },
  { name: 'mail', svg: <Mail /> },
  { name: 'mail-star', svg: <MailStar /> },
  { name: 'smartphone', svg: <SmartPhone /> },
  { name: 'location-point', svg: <LocationPoint /> },
  { name: 'calendar', svg: <Calendar /> },
  { name: 'link', svg: <Link /> },
  { name: 'receipt-torn', svg: <ReceiptTorn /> },
  { name: 'check-circle', svg: <CheckCircle /> },
  { name: 'circle-outline', svg: <CircleOutline /> },
  { name: 'edit-list', svg: <EditList /> },
  { name: 'plus', svg: <Plus /> },
  { name: 'clipboard-notes', svg: <ClipboardNotes /> },
  { name: 'arrow-both', svg: <ArrowBoth /> },
  { name: 'logout', svg: <Logout /> },
  { name: 'plus-black', svg: <PlusBlack /> },
  { name: 'edit-list-black', svg: <EditListBlack /> },
  { name: 'info-circle', svg: <InfoCircle /> },
  { name: 'card-login', svg: <CardLogin /> },
  { name: 'red-trash', svg: <RedTrash /> },
  { name: 'upload-location', svg: <UploadLocation /> },
];

interface Props extends PropsWithChildren<ComponentPropsWithRef<'span'>> {
  name: string;
}

const Icon = (props: Props): JSX.Element => {
  const { name, ...filteredProps } = props;
  const icon = iconMapping.find((i) => i.name === name);

  return icon ? React.cloneElement(icon.svg, { ...filteredProps }) : <></>;
};

export default Icon;
